export default __webpack_public_path__ + "static/media/logo_SVS_new_EN.fd9efdcb.svg";